const QuestionTabHeader =() =>{
    return(
       <>
      <div className="interview-config-header">
        <div className="interview-config-header-title-section">
          <h1 className="interview-config-header-title">
            Question Database
          </h1>
          <p className="interview-config-header-subtitle">
            Manage interview questions, organize by categories, and track performance
          </p>
        </div>
      </div>
    </>
    )
}

export default QuestionTabHeader;